<ng-container>
     @if(isLoading()){
        <app-spinner></app-spinner>
    }
    <div class="mx-4 request-bind-step-container">
        <!-- [disabled]="versionCount <= 1" -->
        @if(!this.authService.isPolicyType()){
            <button class="btn btn-sm btn-primary my-1" [disabled]="this.versionNo() || this.isInceptionReferralLock()" (click) = "quoteComparion()" >Select Quote</button>
        }
        @if(quoteRagDetails()){
            <p class="bg-secondary px-4 py-3 rounded">{{quoteFeedbackMessage()}}</p>
        }
        <form [formGroup]="quoteSummaryForm">
            <div class="border-top border-bottom bg-secondary bg-gradient">
                <h6 class="mt-2 fw-bold fs-4 text-black mb-3">Quote Summary</h6>
            </div>
                <h6 class="mt-2 fw-semibold fs-4 text-black mb-3">{{IndicationNo()}}: {{this.quoteSummaryForm.get('indicationNo')?.value}}</h6>
                <h6 class="mt-2 fw-semibold fs-4 text-black mb-3">{{IndicationDate()}}: {{this.quoteSummaryForm.get('indicationDate')?.value | date:'MM/dd/yyyy'}}</h6>
                <h6 class="mt-2 fw-semibold fs-4 text-black mb-5">Inception Date: {{this.quoteSummaryForm.get('inceptionDate')?.value | date:'MM/dd/yyyy'}}</h6>

                 <div class="border-top border-bottom bg-secondary bg-gradient">
                        <h6 class="my-2 fw-bold fs-4 text-black">Policy Locations</h6>
                    </div>

            <ng-container formArrayName="address">
                <ng-container *ngFor="let address of this.getAddressForm().controls; let i=index;" [formGroupName]="i">
                   
                        <div class="row border border-bottom border-top-0 border-2 border-secondary py-5">
                        <h6 class="fw-semibold fs-4 mb-3">#{{i+1}} -  {{address.get('streetNum')?.value}},{{address.get('streetName')?.value}}, {{address.get('unitNum')?.value ? address.get('unitNum')?.value + ',' : ''}} {{address.get('city')?.value}}, {{address.get('county')?.value}}, {{address.get('zipcode')?.value}}, {{address.get('state')?.value}}</h6>
                        <h6 class="fw-semibold fs-4 mb-5">Location TIV: {{address.get('locationTIV')?.value | currency:'USD':'$ ':'1.2-2'}}</h6>
                        <ng-container formArrayName="buildings">
                            <ng-container *ngFor="let building of this.getBuildingForm(i).controls; let j = index" [formGroupName]="j">
                                <h6 class="fw-semibold fs-4 mb-5">Building #{{j+1}} - Ordinance or Law: {{building.get('oandLFlag')?.value === 1 ? 'Included' : 'Excluded'}}</h6>
                            </ng-container>
                        </ng-container>
                       
                        </div>
                </ng-container>
            </ng-container>
             <div class="border-top border-bottom bg-secondary bg-gradient">
                            <h6 class="fw-bold fs-4 text-black">Policy Coverage and Deductibles</h6>
                        </div>
                        <div class="row py-2 px-3">
                            <div class="col-7 mb-3">
                                <h6 class="mt-2 fw-bold fs-4 text-black">Cause of Loss Form :</h6>
                            </div>
                            <div class="col-5 mb-3 d-flex align-items-center">
                                <span class="mt-2 fw-semibold fs-4 text-black">{{ this.quoteSummaryForm.get('causeOfLoss')?.value }}</span>
                            </div>
                        
                            <div class="col-7 mb-3">
                                <h6 class="mt-2 fw-bold fs-4 text-black">AOP Deductible :</h6>
                            </div>
                            <div class="col-5 mb-3 d-flex align-items-center">
                                <span class="mt-2 fw-semibold fs-4 text-black">{{ this.quoteSummaryForm.get('aopDeductibleDescription')?.value }}</span>
                            </div>
                            <div class="col-7 mb-3">
                                <h6 class="mt-2 fw-bold fs-4 text-black">Wind/Hail :</h6>
                            </div>
                            <div class="col-5 mb-3 d-flex align-items-center">
                                <span class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('windDeductibleFlag')?.value === 0 ? 'Included' : 'Excluded'}}</span>
                            </div>
                            <div class="col-7 mb-3">
                                <h6 class="mt-2 fw-bold fs-4 text-black">Wind/Hail Deductible :</h6>
                            </div>
                            <div class="col-5 mb-3 d-flex align-items-center">
                                <span class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('windDeductibleDescription')?.value}}</span>
                            </div>
                            <div class="col-7 mb-3">
                                <h6 class="mt-2 fw-bold fs-4 text-black">Property Enhancement :</h6>
                            </div>
                            <div class="col-5 mb-3 d-flex align-items-center">
                                <span class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('propertyExtCoverageType')?.value}}</span>
                            </div>
                            <div class="col-7 mb-3">
                                <h6 class="mt-2 fw-bold fs-4 text-black">Water Damage Coverage :</h6>
                            </div>
                            <div class="col-5 mb-3 d-flex align-items-center">
                                <span class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('waterDamageDescription')?.value}}</span>
                            </div>
                            <div class="col-7 mb-3">
                                <h6 class="mt-2 fw-bold fs-4 text-black">Theft Coverage :</h6>
                            </div>
                            <div class="col-5 mb-3 d-flex align-items-center">
                                <span class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('vandalismDescription')?.value}}</span>
                            </div>
                            @if(this.quoteSummaryForm.get('eqbdFlag')?.value == true) {
                                <div class="col-7 mb-3">
                                    <h6 class="mt-2 fw-bold fs-4 text-black">Equipment Breakdown</h6>
                                </div>
                                <div class="col-5 mb-3 d-flex align-items-center">
                                    <span class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('eqbdFlag')?.value ? 'Coverage Included' : 'No Coverage'}}</span>
                                </div>
                            }
                            
                            <div class="col-7 mb-3">
                                <h6 class="mt-2 fw-bold fs-4 text-black">Total Insured Values</h6>
                            </div>
                            <div class="col-5 mb-3 d-flex align-items-center">
                                <span class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('totalInsuredValue')?.value | currency:'USD':'$ ':'1.2-2'}}</span>
                            </div>
                        </div>
            <div class="row mt-3 py-5">
                <div class="border-top border-bottom bg-secondary bg-gradient">
                    <h6 class="my-2 fw-bold fs-4 text-black">Policy Premium</h6>
                </div>
                <div class="col-12 mb-3 d-flex justify-content-between align-items-center">
                    <h6 class="font-semibold mb-1">Commercial Property</h6>
                    <h6 class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('targetPremium')?.value | currency:'USD':'$ ':'1.2-2'}}</h6>
                </div>
                @if(this.quoteSummaryForm.get('eqbdFlag')?.value == true) {
                <div class="col-12 mb-3 d-flex justify-content-between align-items-center">
                    <h6 class="font-semibold mb-1">Equipment Breakdown</h6>
                    <h6 class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('eqbdPremium')?.value | currency:'USD':'$ ':'1.2-2'}}</h6>
                </div>
            }
                 <div class="col-12 mb-3 d-flex justify-content-between align-items-center">
                    <h6 class="font-semibold mb-1">Inspection Fee</h6>
                    <h6 class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('inspectionFee')?.value | currency:'USD':'$ ':'1.2-2'}}</h6>
                </div>
                <div class="col-12 mb-3 d-flex justify-content-between align-items-center">
                    <h6 class="font-semibold mb-1">Policy Fee</h6>
                    <h6 class="mt-2 fw-semibold fs-4 text-black">{{policyFeeAmount() | currency:'USD':'$ ':'1.2-2'}}</h6>
                </div>
                <div class="col-12 mb-3 d-flex justify-content-between align-items-center">
                    <h6 class="font-semibold mb-1">Surplus Lines Tax</h6>
                    <h6 class="mt-2 fw-semibold fs-4 text-black">{{surplusLinesTaxAmount() | currency:'USD':'$ ':'1.2-2'}}</h6>
                </div>
                <ng-container *ngFor="let taxFee of additionalSLTaxFeeItems()">
                    <div class="col-12 mb-3 d-flex justify-content-between align-items-center">
                        <h6 class="font-semibold mb-1">{{ taxFee.otherDescription || taxFee.description }}</h6>
                        <h6 class="mt-2 fw-semibold fs-4 text-black">{{taxFee.feeAmount | currency:'USD':'$ ':'1.2-2'}}</h6>
                    </div>
                </ng-container>   
                <div class="col-12 mb-3 d-flex justify-content-between align-items-center">
                    <h6 class="font-semibold mb-1">Total Policy Premium</h6>
                    <h6 class="mt-2 fw-semibold fs-4 text-black">{{ this.getTotalPolicyPremium() | currency:'USD':'$ ':'1.2-2'}}</h6>
                </div>            
                
            </div>    
            <div class="row py-5">
                <div class="border-top border-bottom bg-secondary bg-gradient">
                    <h6 class="my-2 fw-bold fs-4 text-black">Optional Coverage</h6>
                </div>
                <div class="col-12 mb-3 d-flex justify-content-between align-items-center">
                    <h6 class="font-semibold mb-1">TRIA Premium (Excl Taxes and Fees)</h6>
                    <h6 class="mt-2 fw-semibold fs-4 text-black">{{this.quoteSummaryForm.get('triaPremium')?.value | currency:'USD':'$ ':'1.2-2'}}</h6>
                </div>
            </div>                   
        </form>
    </div>
    <mat-action-row class="accordion-footer d-flex align-items-stretch justify-content-between py-5 px-6">
        <div class="d-flex align-items-center me-3">
            <img src="assets\icon-assets\png\save-exit-icon.png" alt="Save and Exit" (click)="onSaveIndicationHomeAction()" class="h-40px w-40px cursor-pointer bg-white border border-1 border-secondary p-2 rounded" draggable="false" />
        </div>
        <div class="d-flex">
            @if(this.authService.isPolicyType()){
                <button mat-button type="button" (click)="OnRequestBindAndIssuePolicy()" class="btn btn-lg btn-primary continue-btn">Request Bind</button>  
            }@else {
                @if(isBroker()){
                    <div [attr.title]="this.maxAmendLock() ? 'Maximum amendments reached - Please message and submit referral' : null">
                        <button mat-button type="button" [disabled] = "this.isInceptionReferralLock() || this.maxAmendLock()" (click)="OnAmendQuote()" class="btn btn-lg btn-light-primary me-3 back-btn">Amend Quote</button>
                    </div>
                        <button mat-button type="button" (click)="submitQuoteReferral()"class="btn btn-lg btn-light-primary me-3 back-btn" [disabled] = "this.isInceptionReferralLock()">Submit Referral</button>
                        <button mat-button type="button" [disabled]="!this.proceedToRequestBindAndIssuePolicyStep() || this.isInceptionReferralLock()" (click)="onBrokerRequestBind()" class="btn btn-lg btn-primary continue-btn">Request Bind</button>  
                }
                @if(isUwAdmin()) {
                    <!-- <button type="button" class="btn btn-lg btn-light-primary me-3 back-btn" id="indication-next-1" (click)="onUWAdminAmendQuote()">Amend Quote </button>
                    @if (!isQuoteAmendByUWAdmin()) {
                        <button type="button" class="btn btn-lg btn-light-primary me-3 back-btn" id="indication-next-1" (click)="onApproveQuote()">Approve </button>
                        <button type="button" class="btn btn-lg btn-primary continue-btn" id="indication-next-1" (click)="onDeclineQuote()">Decline</button>
                    }@else {
                        <button type="button" class="btn btn-lg btn-primary continue-btn" id="indication-next-1" (click)="onSubmitQuote()">Submit</button>
                    } -->
                                            <button mat-button type="button" [disabled]="this.isInceptionReferralLock()" (click)="OnRequestBindAndIssuePolicy()" class="btn btn-lg btn-primary continue-btn">Request Bind</button>  

                }
            }
        </div>                                                       
    </mat-action-row>
</ng-container>
